import React from 'react';
import { Coins, UserPlus, Diamond, ChevronLeft, ChevronRight } from 'lucide-react';
import { useWeb3 } from '../../contexts/Web3Context';
import { ethers } from 'ethers';

const ActivitiesList = ({ activities, currentPage, totalPages, onPageChange }) => {
  const { shortenAddress } = useWeb3();

  // Format a BigNumber as USDT with 2 decimal places
  const formatUSDT = (amount) => {
    return `${parseFloat(ethers.utils.formatUnits(amount, 18)).toFixed(2)} USDT`;
  };

  // Get icon and details based on activity type
  const getActivityDetails = (activity) => {
    const activityMode = parseInt(activity.mode.toString());
    
    switch (activityMode) {
      case 0: // Investment
        return {
          icon: <Coins size={20} />,
          iconClass: 'investment',
          title: 'Investment',
          details: 'You have invested in GrichInv platform',
          amount: `-${formatUSDT(activity.usdtAmt)}`,
          isPositive: false
        };
      case 1: // Referral
        return {
          icon: <UserPlus size={20} />,
          iconClass: 'referral',
          title: 'Referral Reward',
          details: `Earned from referral ID ${activity.refId.toString()}`,
          amount: `+${formatUSDT(activity.usdtAmt)}`,
          isPositive: true
        };
      case 2: // Royalty
        return {
          icon: <Diamond size={20} />,
          iconClass: 'royalty',
          title: 'Royalty Distribution',
          details: 'Received from global royalty pool',
          amount: `+${formatUSDT(activity.usdtAmt)}`,
          isPositive: true
        };
      default:
        return {
          icon: <Coins size={20} />,
          iconClass: 'investment',
          title: 'Unknown Activity',
          details: 'Details unavailable',
          amount: `${formatUSDT(activity.usdtAmt)}`,
          isPositive: false
        };
    }
  };

  return (
    <div className="activities-container">
      <div className="activities-list">
        {activities.length > 0 ? (
          activities.map((activity, index) => {
            const { icon, iconClass, title, details, amount, isPositive } = getActivityDetails(activity);
            
            return (
              <div key={index} className="activity-item">
                <div className={`activity-icon ${iconClass}`}>
                  {icon}
                </div>
                <div className="activity-content">
                  <div className="activity-header">
                    <div className="activity-title">{title}</div>
                    <div className="activity-date">N/A</div> {/* We don't have timestamp in the contract data */}
                  </div>
                  <div className="activity-details">
                    {details}
                  </div>
                  <div className={`activity-amount ${isPositive ? 'positive' : ''}`}>
                    {amount}
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div className="empty-message" style={{ 
            textAlign: 'center', 
            padding: '30px',
            color: 'var(--text-muted)'
          }}>
            No activities found
          </div>
        )}
      </div>
      
      <div className="activities-pagination">
        <button 
          id="prevPage" 
          disabled={currentPage <= 1}
          onClick={() => onPageChange(currentPage - 1)}
        >
          <ChevronLeft size={14} /> Previous
        </button>
        <span id="pageIndicator">Page {currentPage} of {totalPages}</span>
        <button 
          id="nextPage" 
          disabled={currentPage >= totalPages}
          onClick={() => onPageChange(currentPage + 1)}
        >
          Next <ChevronRight size={14} />
        </button>
      </div>
    </div>
  );
};

export default ActivitiesList;
